import {
  Box,
  Heading,
  IconInfo,
  Inline,
  Stack,
  Text,
  TooltipRenderer,
} from 'braid-design-system';
import { type ComponentProps, type FC, useId } from 'react';

interface Props {
  children: ComponentProps<typeof Stack>['children'];
  title: string;
  tooltip?: string;
}

export const ProfileSection: FC<Props> = ({ children, title, tooltip }) => {
  const id = useId();

  return (
    <Stack space="medium">
      {tooltip ? (
        <Inline space="xsmall" alignY="center">
          <Heading level="4">{title}</Heading>
          <TooltipRenderer
            id={id}
            tooltip={<Text size="small">{tooltip}</Text>}
            placement="top"
          >
            {({ triggerProps }) => (
              <Box {...triggerProps} aria-label="tooltip-trigger">
                <Text size="small">
                  <IconInfo />
                </Text>
              </Box>
            )}
          </TooltipRenderer>
        </Inline>
      ) : (
        <Heading level="4">{title}</Heading>
      )}
      {children}
    </Stack>
  );
};
